import { useRouter } from 'next/router';
import { useEffect, useState, useCallback } from 'react';
const useGuideRouter = () => {
  const router = useRouter();
  const { query, pathname } = router;
  const eventId = String(query?.eventid);
  /** 是否展示指引 */
  const [isShowHeaderTips, updateHeaderTips] = useState(false);
  /** 是否展示抽屉动画 */
  const [isShowHeaderAnimation, updateShowState] = useState(false);
  useEffect(() => {
    getTips(pathname);
  }, [pathname]);

  /** 动画关闭方法 */
  const closeAnimation = useCallback(() => {
    updateShowState(false);
    const arr = JSON.parse(localStorage.getItem('AnimationClosedArray') || '[]');
    if (arr.indexOf(eventId) === -1) arr.push(eventId);
    localStorage.setItem('AnimationClosedArray', JSON.stringify(arr));
  }, [eventId]);
  /** 关闭指引弹框 */
  const closeHeaderTips = useCallback(() => {
    updateHeaderTips(false);
    localStorage?.setItem(`${eventId}_guide`, '2');
  }, [isShowHeaderTips, eventId]);

  const getTips = (url: any) => {
    const isShowTips = localStorage.getItem(`${eventId}_guide`) === '1';
    if (url !== '/event/[eventid]' && isShowTips) {
      updateHeaderTips(true);
    }
  };
  return {
    isShowHeaderTips,
    isShowHeaderAnimation,
    closeHeaderTips,
    updateShowState,
    closeAnimation,
  };
};
export default useGuideRouter;
